<script>
    import TimepickerInline from '../course/TimepickerInline';

    export default {
        components: {TimepickerInline},
        data() {
            return {
                view: 'list',
                disabilities: [],
                filters: {
                    age: '',
                    days: [],
                    disabilities: [],
                    startTime: ''
                },
                time: {
                    hours: 0,
                    minutes: 0
                }
            }
        },
        computed: {
            orderedDays() {
                let lastDay = this.commonWeekDays.shift()
                this.commonWeekDays.push(lastDay)
                return this.commonWeekDays
            }
        },
        watch: {
            time: {
                handler(val) {
                    let hours = val.hours > 9 ? val.hours : `0${val.hours}`
                    let minutes = val.minutes > 9 ? val.minutes : `0${val.minutes}`
                    this.filters.startTime = `${hours}:${minutes}:00`

                    if (hours === "00" && minutes === "00")
                        this.filters.startTime = "";
                },
                deep: true
            }
        },
        mounted() {
            this.getDisabilities()
            this.initPopover()

            let view = this.getParameterByName('view')
            if (view) {
                this.$set(this, 'view', view)
            }

            let filters = this.getParameterByName('filters')
            if (!_.isEmpty(filters)) {
                filters = JSON.parse(filters);
                for (let field in filters) {
                    if (this.filters.hasOwnProperty(field)) {
                        this.$set(this.filters, field, filters[field])
                    }
                }
            }
        },
        methods: {
            switchView() {
                if (this.view == 'map') {
                    this.$set(this, 'view', 'list')
                } else {
                    this.$set(this, 'view', 'map')
                }

                this.$bus.$emit('update-view', this.view)
            },
            applyFilters(filter) {
                this.toggleMenu($(this.$refs[filter]).attr('id'))

                this.$bus.$emit('update-filters', this.filters)
                // console.log('eccomi');
                // this.$emit('update-filters', this.filters)
            },
            removeAgeFilter() {
                this.toggleMenu($(this.$refs['age']).attr('id'))
                this.filters.age = '';
                this.$bus.$emit('update-filters', this.filters)
            },
            removeDaysFilter() {
                this.toggleMenu($(this.$refs['days']).attr('id'))
                this.filters.days = [];
                this.$bus.$emit('update-filters', this.filters)
            },
            removeTimeFilter() {
                this.toggleMenu($(this.$refs['time']).attr('id'));
                this.time.hours = 0;
                this.time.minutes = 0;
                this.filters.startTime = null;
                console.log('ciao');
                this.$bus.$emit('update-filters', this.filters)
            },
            removeDisabilitiesFilter() {
                this.toggleMenu($(this.$refs['disabilities']).attr('id'))
                this.filters.disabilities = [];
                this.$bus.$emit('update-filters', this.filters)
            },
            initPopover() {
                $('[data-toggle="popover"]').popover()
                $('[data-toggle="popover"]').on('click', function (e) {
                    $('[data-toggle="popover"]').not(this).popover('hide');
                });
            },
            toggleMenu(menuId) {
                $(".dropdown-menu").each(function (idx) {
                    if ($(this).attr('id') != menuId) {
                        $(this).removeClass('show')
                    }
                })
                if ($(`#${menuId}`).hasClass('show')) {
                    $(".dropdown-menu").removeClass('show')
                    $(".overlay-filters").removeClass('active')
                } else {
                    $(`#${menuId}`).toggleClass('show')
                    $(".overlay-filters").addClass('active')
                }
            },
            getDisabilities() {
                axios({
                    method: 'get',
                    url: '/disabilities'
                }).then(({data}) => {
                    this.disabilities = data.disabilities
                }).catch((error) => {
                    //
                })
            },
            onSelectDisability(disability) {
                let idx = this.filters.disabilities.indexOf(disability.id)
                if (idx >= 0) {
                    this.filters.disabilities.splice(idx, 1)
                } else {
                    this.filters.disabilities.push(disability.id)
                }
            },
            isSelectedDisability(disability) {
                return this.filters.disabilities.indexOf(disability.id) >= 0
            },
            onSelectedDay(day) {
                let currentDay = day.value - 1
                if (currentDay < 0) {
                    currentDay = this.orderedDays.length - 1
                }

                let idx = this.filters.days.indexOf(currentDay)
                if (idx >= 0) {
                    this.filters.days.splice(idx, 1)
                } else {
                    this.filters.days.push(currentDay)
                }
            },
            isSelectedDay(day) {
                let currentDay = day.value - 1
                if (currentDay < 0) {
                    currentDay = this.orderedDays.length - 1
                }
                return this.filters.days.indexOf(currentDay) >= 0
            },
            incrementAge() {
                if (_.isNumber(this.filters.age)) {
                    this.filters.age++
                } else {
                    this.filters.age = 1
                }
            },
            decrementAge() {
                if (!_.isNumber(this.filters.age) || this.filters.age == 1) return

                this.filters.age--
            },
            getParameterByName(name, url) {
                if (!url) url = window.location.href;

                name = name.replace(/[\[\]]/g, '\\$&');
                var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
                    results = regex.exec(url);

                if (!results) return null;
                if (!results[2]) return '';

                return decodeURIComponent(results[2].replace(/\+/g, ' '));
            },
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/search/SearchViewFiltersContainer.vue